/**
 * Общие константы для приложения
 */

// Маршруты
export const ROUTES = {
  ONBOARDING_STEP_1: '/onboarding/step-1',
  RESUMES_LIST: '/resumes',
  LOGIN: '/login',
} as const

// Сообщения об ошибках
export const ERROR_MESSAGES = {
  MUST_BE_LOGGED_IN: 'You must be logged in',
  MUST_BE_LOGGED_IN_TO_UPLOAD_RESUME: 'You must be logged in to upload a resume',
  MUST_BE_LOGGED_IN_TO_CONVERT_RESUME: 'You must be logged in to convert resume',
  MUST_BE_LOGGED_IN_TO_DELETE_RESUME: 'You must be logged in to delete resume',
} as const
